import {resetEmbed} from "./embed.ts";

export default ($container: HTMLElement): void => {
    $container.querySelectorAll<HTMLDivElement>('.assets').forEach((gallery) => {
        const items = gallery.querySelectorAll<HTMLElement>('.asset');
        const nextBtn = gallery.querySelector<HTMLElement>('.arrow-next');
        const prevBtn = gallery.querySelector<HTMLElement>('.arrow-prev');
        const currentEl = gallery.querySelector<HTMLElement>('.current');

        let activeItem = gallery.querySelector<HTMLElement>('.asset.active');
        let index = Array.from(items).indexOf(activeItem!);

        let xDown: number | null = null;
        let yDown: number | null = null;
        let xDiff = 0;
        let yDiff = 0;

        if (items.length <= 1) {
            return;
        }

        const activate = (key: number): void => {
            activeItem?.classList.remove('active');
            activeItem = items[key];
            activeItem?.classList.add('active');

            if (currentEl) {
                currentEl.innerHTML = String(key + 1);
            }

            index = key;
            resetEmbed();
        };

        const preload = (): void => {
            const nextSibling = activeItem?.nextElementSibling;
            const lazyEl = nextSibling?.querySelector('.lazyload');
            lazyEl?.classList.add('lazypreload');
        };

        const next = (): void => {
            activate(++index < items.length ? index : 0);
            preload();
        };

        const prev = (): void => {
            activate(--index < 0 ? items.length - 1 : index);
        };

        const isInColumns = gallery.closest('.columns') !== null;

        if (isInColumns) {
            gallery.addEventListener('mouseenter', next);
            gallery.addEventListener('mouseleave', next);
            gallery.addEventListener('touchend', next);
        } else {
            gallery.addEventListener('touchstart', (e: TouchEvent) => {
                xDown = e.touches[0].clientX;
                yDown = e.touches[0].clientY;
                xDiff = 0;
                yDiff = 0;
            });

            gallery.addEventListener('touchmove', (e: TouchEvent) => {
                if (xDown === null || yDown === null) return;

                xDiff = xDown - e.touches[0].clientX;
                yDiff = yDown - e.touches[0].clientY;
            });

            gallery.addEventListener('touchend', () => {
                const swipeThreshold = 20;

                if (Math.abs(xDiff) > Math.abs(yDiff) && Math.abs(xDiff) > swipeThreshold) {
                    if (xDiff > 0) {
                        next();
                    } else {
                        prev();
                    }
                }
            });
        }

        nextBtn!.onclick = next;
        prevBtn!.onclick = prev;

        preload();
    });
};
